import { FC } from 'react';
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
} from '@xyflow/react';
import { AlgorithmTargetMappingsGraphEdgeLabel } from './AlgorithmTargetMappingsGraphEdgeLabel';
import { AlgorithmTargetMappingEdge } from './types';

export const AlgorithmTargetMappingsGraphEdge: FC<
  EdgeProps<AlgorithmTargetMappingEdge>
> = (props) => {
  const { ruleCode } = props.data;
  const [edgePath, labelX, labelY] = getBezierPath(props);
  return (
    <>
      <BaseEdge path={edgePath} />
      <EdgeLabelRenderer>
        <AlgorithmTargetMappingsGraphEdgeLabel
          ruleCode={ruleCode}
          x={labelX}
          y={labelY}
        />
      </EdgeLabelRenderer>
    </>
  );
};
